import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import './myImgs.scss'

library.add( faBan );

export default function MyImg(props) {
    const { id, src, delImg} = props;
    return(
        <div className='imgParent'>
            <FontAwesomeIcon icon='ban' onClick={ el => { selImg(delImg, el)} } />
            <img src={ src } alt="" className='selectedImage' id={'image-' + id}/>
            <input
                type="radio"
                name="main"
                value={ id } className={ id === 0 ? 'checked': '' }
                onClick={ changeMain }
            />
        </div>

    )
}

function changeMain (el) {
    let th = el.target;
    if (th.classList.contains('checked')) return;
    document.querySelectorAll('.imgParent > input[type=radio]').forEach(el => {
        el.classList.remove('checked');
    });
    th.classList.add('checked');
}

function selImg (delImg, el) {
    let th = el.target.closest('.imgParent').querySelector('img');
    let id = th.getAttribute('id').split('-')[1];
    delImg(id);
}
